import Actions from './action';
export const initState = {
	commissionSummaryByIDLoading: true,
	commissionSummaryByIDData: [],
	commissionSummaryByAffData: [],
	commissionSummaryByAffDataLoading: false,
	commissionSummaryByIDCommissionProfileLoading: true,
	commissionSummaryByIDCommissionProfileData: [],
	editCommissionSummaryByIDLoading: false,
	transferCommissionSummaryByIDLoading: false,
	editCommissionSummaryByIDError: false,
	modalOptions: {
		modalType: '',
		modalVisible: false,
	},
};

const commissionSummaryByIDReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED: {
			return {
				...state,
				commissionSummaryByIDLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED_SUCCESS: {
			return {
				...state,
				commissionSummaryByIDLoading: false,
				commissionSummaryByIDData: action.response,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_STARTED_FAIL: {
			return {
				...state,
				commissionSummaryByIDLoading: false,
				commissionSummaryByIDData: [],
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_STARTED: {
			return {
				...state,
				commissionSummaryByIDCommissionProfileLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_SUCCESS: {
			return {
				...state,
				commissionSummaryByIDCommissionProfileLoading: false,
				commissionSummaryByIDCommissionProfileData: action.response,
			};
		}
		case Actions.types.GET_AFFILIATE_BY_ID_COMMISSION_PROFILES_FAIL: {
			return {
				...state,
				commissionSummaryByIDCommissionProfileLoading: false,
				commissionSummaryByIDCommissionProfileData: [],
			};
		}
		case Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED: {
			return {
				...state,
				editCommissionSummaryByIDLoading: true,
			};
		}
		case Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS: {
			return {
				...state,
				editCommissionSummaryByIDLoading: false,
				editCommissionSummaryByIDError: false,
			};
		}
		case Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL: {
			return {
				...state,
				editCommissionSummaryByIDLoading: false,
				editCommissionSummaryByIDError: action.errMsg,
			};
		}
		case Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_SUCCESS: {
			return {
				...state,
				editCommissionSummaryByIDLoading: false,
			};
		}
		case Actions.types.GET_COMMISSION_SUMMARY_BY_ID_STARTED: {
			return {
				...state,
				commissionSummaryByAffDataLoading: true,
			};
		}
		case Actions.types.GET_COMMISSION_SUMMARY_BY_ID_SUCCESS: {
			return {
				...state,
				commissionSummaryByAffData: action.response,
				commissionSummaryByAffDataLoading: false,
			};
		}
		case Actions.types.GET_COMMISSION_SUMMARY_BY_ID_FAIL: {
			return {
				...state,
				commissionSummaryByAffDataLoading: false,
			};
		}
		case Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_FAIL: {
			return {
				...state,
				editCommissionSummaryByIDLoading: false,
			};
		}
		case Actions.types.SET_MODAL_OPTIONS: {
			return {
				...state,
				modalOptions: action.modalOptions,
			};
		}
		default:
			return state;
	}
};

export default commissionSummaryByIDReducer;
